import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import ArticleGenerator from "@/components/stealth-writer/GenerateArticle";
import { ArticleFormProvider } from "@/components/stealth-writer/GenerateArticle/ArticleFormContext";
import { userPlanQueryOptions } from "@/lib/queries/payment/userPlan";
import { UpgradePlanModal } from "@/components/stealth-writer/UpgradePlanModal";

export const Route = createFileRoute(
  "/_app/stealth-ai-writer/generate-article",
)({
  component: RouteComponent,
  async loader({ context: { queryClient } }) {
    await queryClient.prefetchQuery(userPlanQueryOptions);
  },
});

function RouteComponent() {
  const plan = useSuspenseQuery(userPlanQueryOptions);
  const forUpgradePlan = ["Free Plan", "Standard Plan"];
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  // TODO: clean this thing up
  useEffect(() => {
    if (forUpgradePlan.includes(plan.data.info?.plan.name ?? "")) {
      setShowUpgradeModal(true);
    }
  }, [plan.data.info?.plan.name]);

  // TODO: clean this thing up too
  if (forUpgradePlan.includes(plan.data.info?.plan.name ?? "")) {
    return (
      <UpgradePlanModal
        open={showUpgradeModal}
        onOpenChange={setShowUpgradeModal}
      />
    );
  }

  return (
    <ArticleFormProvider>
      <ArticleGenerator />
    </ArticleFormProvider>
  );
}
